module.exports = __webpack_public_path__ + "assets/TEquilateral.c1c6e4b1762a5c4da4976a82025827cf.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TEquilateral.gmt
// module id = 1011
// module chunks = 0